"use strict";
/**
 * @note : THESE ARE NOT MEANT TO BE EXPORTED
 *
 * These are utility functions that make certain tasks
 * within oolib easier
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimaryColorText = exports.getPrimaryColor100 = exports.getPrimaryColor40 = exports.getPrimaryColor10 = exports.useLocale = void 0;
var react_1 = __importDefault(require("react"));
var colors_1 = require("../themes/colors");
var styled_components_1 = require("styled-components");
var primaryColor10 = colors_1.colors.primaryColor10, primaryColor40 = colors_1.colors.primaryColor40, primaryColor100 = colors_1.colors.primaryColor100, primaryColorText = colors_1.colors.primaryColorText;
/**
 * Generates a function that localizes a value based on the current theme.
 *
 * @param {ReactNode} value - The value to be localized
 * @return {ReactNode} The localized value
 */
var useLocale = function () {
    var currentTheme = (0, styled_components_1.useTheme)();
    var localize = function (value) {
        // Check if the value is a React component or a JavaScript object
        if (react_1.default.isValidElement(value) || typeof value === 'object') {
            return value;
        }
        // If the value is a string, attempt to localize it
        if (typeof value === 'string') {
            return (currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.localize) ? currentTheme.localize(value) : value;
        }
        // If the value is a React element or another type of value, render it as-is
        return value;
    };
    return localize;
};
exports.useLocale = useLocale;
/**
 * Returns the primary color at 10% opacity from the provided colors object or falls back to a default primary color
 *
 * @param {ColorsType} colors - An optional ColorsType object to retrieve the primary color from
 * @return {string} The primary color value at 10% opacity
 */
var getPrimaryColor10 = function (colors) {
    return (colors === null || colors === void 0 ? void 0 : colors.primaryColor10) || primaryColor10;
};
exports.getPrimaryColor10 = getPrimaryColor10;
/**
 * Returns the primary color at 40% opacity from the provided colors object or falls back to a default primary color.
 *
 * @param {ColorsType} colors - An optional ColorsType object to retrieve the primary color from
 * @return {string} The primary color at 40% opacity.
 */
var getPrimaryColor40 = function (colors) {
    return (colors === null || colors === void 0 ? void 0 : colors.primaryColor40) || primaryColor40;
};
exports.getPrimaryColor40 = getPrimaryColor40;
/**
 * Returns the primary color at 100% opacity from the provided colors object or falls back to a default primary color.
 *
 * @param {ColorsType} colors - Optional colors object containing primary color levels.
 * @return {string} The primary color at 100 level.
 */
var getPrimaryColor100 = function (colors) {
    return (colors === null || colors === void 0 ? void 0 : colors.primaryColor100) || primaryColor100;
};
exports.getPrimaryColor100 = getPrimaryColor100;
/**
 * Get the primary color text.
 *
 * @param {ColorsType} colors - Optional colors object
 * @return {string} The primary color text
 */
var getPrimaryColorText = function (colors) {
    return (colors === null || colors === void 0 ? void 0 : colors.primaryColorText) || primaryColorText;
};
exports.getPrimaryColorText = getPrimaryColorText;
